import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service de contact
 */
@Injectable({
  providedIn: 'root'
})
export class ContactService {

  /**
   * Constructeur
   * @param http
   */
  constructor(private http: HttpClient) {
  }

  /**
   * Obtenir les données de la demande
   */
  obtenirDonnees() {
    return this.http.get(`api/contact/obtenirdonnees`).pipe(map(retour => { return retour; }));
  }

  /**
   * Envoyer la demande de contact
   */
    envoyerDemande(modele: Object) {
    return this.http.post(`api/contact/envoyerdemande`, modele).pipe(map((retour: any): any => { return retour }));
  }
}
